import * as moment from 'moment';

export class Log {
    ip: string;
    maillistId: string;
    contactId: string;
    siteId: string;
    emailId: string;
    action: string;
    userName: string;
    password: string;
    createdAt: Date;

    constructor(data) {
        Object.assign(this, data);

        this.createdAt = moment(this.createdAt).toDate();
    }
}